/* eslint-disable consistent-return */
import { FormikConfig, FormikValues } from 'formik';
import React from 'react';
import * as yup from 'yup';
import PropertyPalFormikWithRef from './PropertyPalFormikWithRef';

interface PropertyPalFormProps extends FormikConfig<FormikValues> {
  formRef?: React.Ref<any>;
  initialValues: any;
  validationSchema?: yup.AnySchema;
  onBeforeSubmit?: () => boolean;
  onSubmit: (values: any, { setErrors }: any) => void;
  enableReinitialize?: boolean;
  formTestId?: string;
  loading?: boolean;
}

const PropertyPalForm: React.FC<PropertyPalFormProps> = (props) => {
  const { formRef, children, initialValues, validationSchema, enableReinitialize } = props;
  const onSubmit = (values: any, helpers: any) => {
    if (!props.loading) {
      return props.onSubmit(values, helpers);
    }
  };

  return (
    <PropertyPalFormikWithRef
      enableReinitialize={enableReinitialize}
      validateOnChange
      validateOnMount
      validateOnBlur
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      innerRef={formRef}
    >
      {(p) => {
        return (
          <form
            data-testid={props.formTestId}
            onSubmit={(e) => {
              return p.handleSubmit(e);
            }}
          >
            {typeof children === 'function' ? children(p) : children}
          </form>
        );
      }}
    </PropertyPalFormikWithRef>
  );
};

export default PropertyPalForm;
